/**
 * Correos principales y datos de contacto del Concejo.
 * Se muestran en todo el sitio (footer, acerca, contacto, home, etc.)
 */
export const EMAIL_PRINCIPAL_1 = 'concejodeguachucal@gmail.com';
export const EMAIL_PRINCIPAL_2 = 'contacto@concejodeguachucal.gov.co';

export const CORREOS_PRINCIPALES = [EMAIL_PRINCIPAL_1, EMAIL_PRINCIPAL_2];

export const TELEFONO_DEFAULT = '+57 (316) 3666 037';
export const DIRECCION_DEFAULT = 'Calle Principal, Guachucal, Nariño';
export const HORARIO_DEFAULT = 'Lunes a Viernes: 8:00 AM - 12:00 PM y 2:00 PM - 6:00 PM';
